import * as glMatrix from 'gl-matrix';
import { Camera } from "./GL/scene/camera.js";
import { Chart, CategoryScale, LinearScale, BarElement, BarController } from 'chart.js';
import { StampTool } from './GL/operations/tools/stamp.js';
import { BrushTool } from './GL/operations/tools/brush.js';
import { GumTool } from './GL/operations/tools/gum.js';
import { DensityTool } from './GL/operations/tools/density.js';
import { LuminosityContrastFilter } from './GL/operations/filters/luminosityContrast.js';
import { HueSaturationFilter } from './GL/operations/filters/hueSaturation.js';
import { ColorBalanceFilter } from './GL/operations/filters/colorBalance.js';
import { LevelsFilter } from './GL/operations/filters/levels.js';
import { SharpenFilter } from './GL/operations/filters/sharpen.js';
import { Histogram } from './GL/histogram.js';
import { GLEngine } from './GL/engine.js';
import { PhotoshopWidget } from './UI/photoshopWidget.js';
import { saveAs } from 'file-saver';
import { Alpha2ColorFilter } from './GL/operations/filters/alpha2Color.js';
import { SelectiveCorrectionFilter } from './GL/operations/filters/selectiveCorrection.js';

Chart.register(CategoryScale);
Chart.register(LinearScale);
Chart.register(BarElement);
Chart.register(BarController);

export class PhotoshopController {
    histogram: Histogram | null;
    PSEngine: GLEngine | null;
    PSCamera: Camera;
    PSRequestAnimationFrameId: number | null;
    PSMoveEvent: any | null;
    PSColor: any;
    PSRotationMode: any | null;
    initializeToolRange: any;
    photoshopWidget: PhotoshopWidget;

    constructor(initializeToolRangeCallback, photoshopWidget) {
        // private variables
        this.histogram = null;

        // public variables
        this.PSEngine = null;
        this.PSCamera = new Camera(false);
        this.PSRequestAnimationFrameId = null;
        this.PSMoveEvent = null;
        this.PSColor = glMatrix.vec4.fromValues(0, 0, 0, 1);
        this.PSRotationMode = null;
        this.initializeToolRange = initializeToolRangeCallback;
        this.photoshopWidget = photoshopWidget;
    }

    unreal_after() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.selection.clear();
        this.PSEngine.activeLayer = this.PSEngine.mainLayer;
        var selectedOperation = null;
        this.setActiveOperation('sharpen');
        selectedOperation = this.PSEngine.activeOperation;
        this.PSEngine.activeOperation.radius = 1;
        this.PSEngine.activeOperation.gain = 150;
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.setActiveOperation('alpha2color');
        this.PSEngine.activeOperation.color = [1, 1, 1, 1];
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.setActiveOperation('selectiveCorrection');
        this.PSEngine.activeOperation.whiteAdjust[3] = -1;
        this.PSEngine.activeOperation.neutralAdjust[3] = 0;
        this.PSEngine.activeOperation.blackAdjust[3] = 0.05;
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.PSEngine.activeOperation = selectedOperation;
        this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
    }

    unreal_axo() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.selection.clear();
        this.PSEngine.activeLayer = this.PSEngine.mainLayer;
        var selectedOperation = null;
        this.setActiveOperation('sharpen');
        selectedOperation = this.PSEngine.activeOperation;
        this.PSEngine.activeOperation.radius = 1;
        this.PSEngine.activeOperation.gain = 150;
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.setActiveOperation('alpha2color');
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.PSEngine.activeOperation = selectedOperation;
        this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
    }

    unreal_night() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.selection.clear();
        this.PSEngine.activeLayer = this.PSEngine.mainLayer;
        var selectedOperation = null;
        this.setActiveOperation('sharpen');
        selectedOperation = this.PSEngine.activeOperation;
        this.PSEngine.activeOperation.radius = 1;
        this.PSEngine.activeOperation.gain = 150;
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.PSEngine.activeOperation = selectedOperation;
        this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
    }

    packshot() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.selection.clear();
        this.PSEngine.activeLayer = this.PSEngine.mainLayer;
        var selectedOperation = null;
        this.setActiveOperation('sharpen');
        selectedOperation = this.PSEngine.activeOperation;
        this.PSEngine.activeOperation.radius = 1;
        this.PSEngine.activeOperation.gain = 150;
        this.PSEngine.addOperation(this.PSEngine.activeOperation);

        this.PSEngine.activeOperation = selectedOperation;
        this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
    }

    /**private functions */
    setActiveOperation(value, operation?) {
        if (this.PSEngine && this.PSEngine.layers.length === 0) {
            return;
        }
        if (!this.PSEngine) {
            return;
        }
        switch (value) {

            case 'stamp':
                this.PSEngine.pipette.active = false;
                this.PSEngine.activeOperation = new StampTool(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height);
                this.initializeToolRange();
                break;
            case 'brush':
                this.PSEngine.pipette.active = false;
                this.PSEngine.activeOperation = new BrushTool(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height);
                this.PSColor = this.PSEngine.activeOperation.color;
                ($('#color-picker') as any).spectrum('set', { r: this.PSColor[0], g: this.PSColor[1], b: this.PSColor[2], a: this.PSColor[3] });
                this.initializeToolRange();
                break;
            case 'gum':
                this.PSEngine.pipette.active = false;
                this.PSEngine.activeOperation = new GumTool(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height);
                this.initializeToolRange();
                break;
            case 'density':
                this.PSEngine.pipette.active = false;
                this.PSEngine.activeOperation = new DensityTool(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height);
                this.initializeToolRange();
                break;
            case 'luminosityContrast':
                this.PSEngine.activeOperation = (operation ? operation : new LuminosityContrastFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                break;
            case 'hueSaturation':
                this.PSEngine.activeOperation = (operation ? operation : new HueSaturationFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                break;
            case 'colorBalance':
                this.PSEngine.activeOperation = (operation ? operation : new ColorBalanceFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                break;
            case 'levels':
                this.PSEngine.activeOperation = (operation ? operation : new LevelsFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                const imageData = this.PSEngine.grabImage();
                if (imageData) {
                    this.histogram = new Histogram(Array.from(imageData.data), this.PSEngine.width, this.PSEngine.height);
                    this.initializeHistogramChart();
                }
                break;
            case 'sharpen':
                this.PSEngine.activeOperation = (operation ? operation : new SharpenFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                break;
            case 'alpha2color':
                this.PSEngine.activeOperation = (operation ? operation : new Alpha2ColorFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                break;
            case 'selectiveCorrection':
                this.PSEngine.activeOperation = (operation ? operation : new SelectiveCorrectionFilter(this.PSEngine.gl, this.PSEngine.width, this.PSEngine.height));
                break;
            default:
                this.PSEngine.activeOperation = null;
                break;
        }

        if (this.PSEngine.activeOperation) {
            this.PSEngine.selection.active = false;
        }
        if (this.photoshopWidget.activeOperationWidget) {
            this.photoshopWidget.toolspanelWidget.updateClass();
            this.photoshopWidget.activeOperationWidget.updateIf();
            this.photoshopWidget.activeOperationWidget.updateClass();
        }
    }

    addOperation() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.addOperation(this.PSEngine.activeOperation);
        if (this.photoshopWidget.activeOperationWidget) {
            this.photoshopWidget.activeOperationWidget.updateIf();
            this.photoshopWidget.activeOperationWidget.updateClass();
        }
        this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
    }

    layerRotation(value?) {
        if (!this.PSEngine) {
            return;
        }
        if (!this.PSEngine.activeLayer) {
            return 0;
        }

        if (value !== undefined) {
            this.PSEngine.activeLayer.setRotation(this.PSRotationMode, value * Math.PI / 180);
            this.PSEngine.activeLayer.touch();
            this.update();
        } else {
            return Math.round(this.PSEngine.activeLayer.getRotation(this.PSRotationMode) * 180 / Math.PI);
        }
    }

    isEditing() {
        if (!this.PSEngine) {
            return;
        }
        if (!this.PSEngine.activeLayer) {
            return false;
        }

        return this.PSEngine.activeLayer.operations.indexOf(this.PSEngine.activeLayer.activeOperation) >= 0;
    }

    initializeHistogramChart() {
        if (!this.histogram) {
            return;
        }

        window.setTimeout(() => {
            var element = document.getElementById("histogram");
            if (!element) {
                return;
            }

            const context = element as HTMLCanvasElement;
            new Chart(context, {
                type: 'bar',
                data: {
                    labels: Array.from({ length: 256 }, (_, i) => i),
                    datasets: [{
                        label: '',
                        data: this.histogram ? this.histogram.RGB : [],
                        backgroundColor: '#D1D1D1'
                    }]
                },
                options: {
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    scales: {
                        xAxes: {
                            display: false
                        },
                        yAxes: {
                            display: false,
                            beginAtZero: true

                        }
                    }
                }
            });
        });
    }

    selectedColor() {
        return { 'background-color': 'rgba(' + this.PSColor[0] + ', ' + this.PSColor[1] + ', ' + this.PSColor[2] + ', ' + this.PSColor[3] + ')' };
    }

    open() {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.addEventListener('change', function () {
            var fileReader = new FileReader();
            fileReader.onload = function (result) {
                var image = new Image();
                image.addEventListener('load', function () {
                    this.PSCamera.reset();
                    this.PSEngine.addLayer(image);
                    this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
                    this.update();
                }.bind(this));
                image.src = result.target.result;
            }.bind(this);
            if (input.files && input.files[0]) {
                fileReader.readAsDataURL(input.files[0]);
            }
            input.remove();
        }.bind(this));
        input.click();
    }

    requestCORSIfNotSameOrigin(img, url) {
        try {
            if ((new URL(url)).origin !== window.location.origin) {
                img.crossOrigin = "";
            }
        } catch (e) { }
    }

    loadAlpha(url, alphaUrl, loaded, error) {
        var image = new Image();
        image.addEventListener('load', function () {
            this.loadImage(url, image, loaded, error);
        }.bind(this));
        image.addEventListener('error', function () {
            if (error) {
                error();
            }
        });
        this.requestCORSIfNotSameOrigin(image, alphaUrl);
        image.src = alphaUrl;
    }

    loadImage(url, imgAlpha, loaded, error) {
        var image = new Image();
        image.addEventListener('load', function () {
            this.PSCamera.reset();
            this.PSEngine.addLayer(image, imgAlpha);
            this.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
            this.update();

            if (loaded) {
                loaded();
            }
        }.bind(this));
        image.addEventListener('error', function () {
            if (error) {
                error();
            }
        });
        this.requestCORSIfNotSameOrigin(image, url);
        image.src = url;
    }

    openFromURL(url, alphaUrl, loaded, error) {
        if (alphaUrl) {
            this.loadAlpha(url, alphaUrl, loaded, error);
        } else {
            this.loadImage(url, null, loaded, error);
        }
    }

    download(format, compression, extention) {
        if (!this.PSEngine) {
            return;
        }
        if (this.PSEngine.layers.length === 0) {
            return;
        }
        const imageData = this.PSEngine.grabImage();
        if (!imageData) {
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.putImageData(imageData, 0, 0);
        }
        var exporter = canvas;
        if (extention.indexOf('jpg') !== -1) {
            exporter = canvas.cloneNode(true) as HTMLCanvasElement;
            var context = exporter.getContext('2d');
            if (context) {
                context.fillStyle = 'white';
                context.fillRect(0, 0, exporter.width, exporter.height);
                context.drawImage(canvas, 0, 0);
            }
        }
        exporter.toBlob(function (blob) {
            if (blob) {
                //save on disk
                saveAs(blob, 'image' + extention);
            }
            canvas.remove();
        }, format, compression);
    }

    NDCPosition(event) {
        if (!this.PSEngine) {
            return;
        }
        var position_NDC = glMatrix.vec2.fromValues((event.offsetX / this.PSEngine.gl.canvas.width) * 2 - 1, (event.offsetY / this.PSEngine.gl.canvas.height) * 2 - 1);
        var scale_transform = glMatrix.mat4.create();
        var pan_transform = glMatrix.mat4.create();

        var translation = glMatrix.vec2.create();
        glMatrix.mat4.multiply(scale_transform, this.PSCamera.zoomInverse, this.PSEngine.imageMesh.modelInverse);
        glMatrix.mat4.multiply(pan_transform, this.PSEngine.imageMesh.modelInverse, this.PSCamera.panInverse);
        glMatrix.vec2.transformMat4(position_NDC, position_NDC, scale_transform);
        glMatrix.vec2.transformMat4(translation, translation, pan_transform);
        position_NDC[0] += translation[0];
        position_NDC[1] -= translation[1];
        return position_NDC;
    }

    addBrushPoint(event) {
        if (!this.PSEngine) {
            return;
        }
        var position_NDC = this.NDCPosition(event);
        this.PSEngine.activeOperation.addPoint(position_NDC);
    }

    update() {
        this.startRendering();
        this.stopRendering();
    }

    touch() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.touch();
    }

    handleMoveEvent() {
        if (!this.PSEngine) {
            return;
        }
        if (!this.PSMoveEvent || this.PSEngine.layers.length === 0) {
            return;
        }

        if (this.PSCamera.started()) {
            this.PSCamera.move(this.PSMoveEvent);
        } else if (this.PSEngine.activeLayer.camera.started() && this.PSEngine.activeLayer.enable) {
            if (!this.PSEngine.activeLayer.hasToolOperation) {
                this.PSEngine.activeLayer.camera.move(this.PSMoveEvent, true);
            }
        }

        if (this.PSMoveEvent.buttons === 1 && this.PSEngine.pipette.activated) {
            var position = glMatrix.vec2.fromValues(this.PSMoveEvent.offsetX, this.PSEngine.gl.canvas.height - this.PSMoveEvent.offsetY);
            this.PSColor = this.PSEngine.pick(this.PSCamera, position);
            ($('#color-picker') as any).spectrum('set', { r: this.PSColor[0], g: this.PSColor[1], b: this.PSColor[2], a: this.PSColor[3] });

        }

        if (this.PSMoveEvent.buttons === 1 && this.PSEngine.selection.activated) {
            this.PSEngine.selection.movePoint(this.NDCPosition(this.PSMoveEvent));
        }

        if (this.PSEngine.activeOperation) {
            if (this.PSMoveEvent.buttons === 1) {
                switch (this.PSEngine.activeOperation.name) {
                    case 'Pinceau':
                    case 'Gomme':
                    case 'Densité':
                    case 'Tampon':
                        this.addBrushPoint(this.PSMoveEvent);
                        break;
                }
            }

            switch (this.PSEngine.activeOperation.name) {
                case 'Tampon':
                    this.PSEngine.activeOperation.mousePosition = this.NDCPosition(this.PSMoveEvent);
                    break;
            }
        }
    }

    render() {
        if (!this.PSEngine) {
            return;
        }
        this.handleMoveEvent();
        this.PSEngine.render(this.PSCamera);
        this.PSRequestAnimationFrameId = window.requestAnimationFrame(this.render.bind(this));
    }

    startRendering() {
        if (!this.PSEngine) {
            return;
        }
        this.PSEngine.render(this.PSCamera);
        this.PSRequestAnimationFrameId = window.requestAnimationFrame(this.render.bind(this));
    }

    stopRendering() {
        if (this.PSRequestAnimationFrameId !== null) {
            window.cancelAnimationFrame(this.PSRequestAnimationFrameId);
        }
        this.PSRequestAnimationFrameId = null;
        this.PSMoveEvent = null;
    }

    startOperation(event) {
        if (!this.PSEngine) {
            return;
        }
        if (this.PSEngine.layers.length === 0) {
            return;
        }

        switch (this.PSEngine.activeOperation.name) {
            case 'Pinceau':
                this.PSEngine.editing = true;
                this.PSEngine.addOperation(this.PSEngine.activeOperation);
                this.PSEngine.activeOperation.color = this.PSColor;
                this.addBrushPoint(event);
                break;
            case 'Gomme':
                this.PSEngine.editing = true;
                this.PSEngine.addOperation(this.PSEngine.activeOperation);
                this.addBrushPoint(event);
                break;
            case 'Densité':
                this.PSEngine.editing = true;
                this.PSEngine.addOperation(this.PSEngine.activeOperation);
                this.addBrushPoint(event);
                break;
            case 'Tampon':
                if (!this.PSEngine.activeOperation.stampPosition) {
                    alert("Impossible d'utiliser le tampon de duplication car la zone à dupliquer n'a pas été définie (Alt-clic pour définir un point source).");
                } else {
                    this.PSEngine.editing = true;
                    this.PSEngine.addOperation(this.PSEngine.activeOperation);
                    this.addBrushPoint(event);
                }
                break;
        }
    }

    endOperation() {
        if (!this.PSEngine) {
            return;
        }
        if (this.PSEngine.layers.length === 0) {
            return;
        }

        switch (this.PSEngine.activeOperation.name) {
            case 'Pinceau':
                this.PSEngine.activeOperation = BrushTool.copy(this.PSEngine.activeOperation);

                break;
            case 'Gomme':
                this.PSEngine.activeOperation = GumTool.copy(this.PSEngine.activeOperation);

                break;
            case 'Densité':
                this.PSEngine.activeOperation = DensityTool.copy(this.PSEngine.activeOperation);

                break;
            case 'Tampon':
                this.PSEngine.activeOperation = StampTool.copy(this.PSEngine.activeOperation);

                break;
        }
        this.PSEngine.editing = false;
    }

    pointerDownHandler(event) {
        if (!this.PSEngine) {
            return;
        }
        this.startRendering();
        if (event.button === 1) {
            if (!event.shiftKey) {
                this.PSCamera.start('PAN', this.PSEngine.gl.canvas.width, this.PSEngine.gl.canvas.height, event);
            } else if (this.PSEngine.activeLayer && this.PSEngine.activeLayer.enable) {
                this.PSEngine.activeLayer.camera.start('PAN', this.PSEngine.width / 2, this.PSEngine.height, event);
            }
        } else if (event.button === 0) {
            if (this.PSEngine.pipette.activated || event.altKey) {
                if (this.PSEngine.activeOperation) {
                    switch (this.PSEngine.activeOperation.program) {
                        case 'stamp':
                            this.PSEngine.activeOperation.init(this.NDCPosition(event));
                            return;
                    }
                }
                var position = glMatrix.vec2.fromValues(event.offsetX, event.currentTarget.clientHeight - event.offsetY);
                this.PSColor = this.PSEngine.pick(this.PSCamera, position);
                ($('#color-picker') as any).spectrum('set', { r: this.PSColor[0], g: this.PSColor[1], b: this.PSColor[2], a: this.PSColor[3] });
                try {
                    window.localStorage.setItem('PSColor', this.PSColor);
                } catch (e) {
                }
            } else if (this.PSEngine.selection.activated) {
                this.PSEngine.selection.addPoint(this.NDCPosition(event));
                this.update();
            } else if (this.PSEngine.activeOperation) {
                this.PSEngine.renderSelection();
                this.startOperation(event);
            }
        }
    }
}
